import { createContext } from 'react';

export enum AuthStep {
  Login = 'login',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  DashboardSelection = 'dashboard-selection',
}

/** How far a step sits from sign-in; moving deeper enters from the right, going back from the left. */
export const authStepDepth: Record<AuthStep, number> = {
  [AuthStep.Login]: 0,
  [AuthStep.ForgotPassword]: 1,
  [AuthStep.ResetPassword]: 1,
  [AuthStep.DashboardSelection]: 1,
};

/**
 * Records the step now shown and returns the step shown before it (`null` on first load).
 * Recording the same step again returns the same answer, so StrictMode effect re-runs agree.
 */
export type AuthStepRecorder = (step: AuthStep) => AuthStep | null;

/** Owned by the persistent auth layout, so the step history survives panel remounts. */
export const AuthStepRecorderContext = createContext<AuthStepRecorder | null>(null);
